module.exports = __webpack_public_path__ + "static/chitra-b-divakaruni-655e1fb7885cace8f978caaed017e7e0.jpg";